import React, { useState } from 'react';
import { Button, ButtonColor, ButtonSize, ButtonVariant, LoadingAnimation, usePopupManager } from 'ui-builder';
import { useParams } from 'react-router-dom';
import MainBlock from '../../shared/web/layout/MainBlock';
import useDownloadLinkService from './downloadLinkService';
import PageTitle from '../../shared/web/PageTitle';

import styles from './DownloadFilePage.module.scss';
import useDataLoader from 'data-loader';
import { DownloadFileDto, formatBytes } from 'nekst-api';
import { downloadFile } from '../downloadFileHelper';
import { DocumentPreviewPopup } from 'features/nekst-widgets';

function FilePreview(
  props: {
    file: DownloadFileDto,
  },
) {
  const popupManager = usePopupManager();

  return (
    <div className={styles.filePreview}>
      <div className={styles.info}>
        <div className={styles.fileName}>
          {props.file.fileName}
        </div>
        <div className={styles.size}>
          {formatBytes(props.file.size)}
        </div>
      </div>
      <div style={{ marginTop: '1rem' }}>
        <Button
          size={ButtonSize.MEDIUM}
          color={ButtonColor.BLUE}
          text="Preview"
          variant={ButtonVariant.FILLED}
          onClick={async () => {
            popupManager.openPopup(<DocumentPreviewPopup document={props.file} />);
          }}
        />
        <Button
          size={ButtonSize.MEDIUM}
          color={ButtonColor.GREEN}
          text="Download"
          variant={ButtonVariant.FILLED}
          onClick={async () => {
            downloadFile(props.file);
          }}
        />
      </div>
    </div>
  );
}

export default function DownloadFilePage() {
  const [fileInfo, setFileInfo] = useState<DownloadFileDto>();

  const service = useDownloadLinkService();

  const params = useParams<{ code: string }>();

  const code = params.code!;

  useDataLoader(
    async () => service.getFileDownloadLink(code),
    setFileInfo,
  );

  if (fileInfo) {
    return (
      <>
        <PageTitle text="Download File" />
        <MainBlock title="Download File">
          <FilePreview file={fileInfo} />
        </MainBlock>
      </>
    );
  } else {
    return (<LoadingAnimation />);
  }
}
